import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { PlusSvg } from './Plus';

export const PlusIcon = createIcon('plus', PlusSvg);
/**
 * @deprecated используйте PlusIcon
 */
export const withPlusIcon = withIcon('plus', PlusSvg);
